import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Signup from "../pages/auth/Signup";
// import Login from "../pages/auth/Login";
import ForgotPasswordFlow from "../pages/auth/ForgotPasswordFlow";
import AddTask from "../pages/task/AddTask";
import NewLogin from "../pages/auth/NewLogin";
import Layout from "../components/common/Layout";
import Dashboard from "../pages/dashboard/DashBoard";
import Projects from "../pages/projects/Projects";
import Actions from "../pages/actions/Actions";
import TaskDetail from "../pages/task/TaskDetail";
import ChangeStatus from "../pages/task/ChangeStatus";
import ClockOutTasks from "../pages/clockOut/ClockOutTasks";
import ClockOutTask from "../pages/clockOut/ClockOutTask";
import Goals from "../pages/goals/Goals";
import GoalView from "../pages/goals/GoalView";
import GoalAddTask from "../pages/task/GoalAddTask";
import CreateGoalFromTemplate from "../pages/goals/CreateGoalFromTemplate";
import AddProject from "../pages/projects/AddProject";
import EditProject from "../pages/projects/EditProject";
import EditTask from "../pages/task/EditTask";
import EditGoal from "../pages/goals/EditGoal";
import AddDependency from "../pages/dependency/AddDependency";
import AddDefect from "../pages/defect/Defect";
import ViewDefect from "../pages/defect/ViewDefect";
import AddEmployee from "../pages/employee/AddEmployee";
import AddBug from "../pages/bug/AddBug";
import ViewBug from "../pages/bug/ViewBug";
import ViewPreDefects from "../pages/defect/ViewPreDefects";
import ViewAttendance from "../pages/attendace/ViewAttendance";
import ProtectedRoute from "../components/Auth/ProtectedRoute";
import ApplyLeave from "../pages/leave/ApplyLeave";
import LeaveManagement from "../pages/leave/LeaveManagement";
import EmployeeTaskList from "../pages/employee/EmployeeTaskList";
import AddMeeting from "../pages/meetings/AddMeeting";
import EditMeeting from "../pages/meetings/EditMeeting";
import MeetingDetail from "../pages/meetings/MeetingDetail";
import ViewCalendar from "../pages/calendar/ViewCalendar";
import Carepreneur from "../pages/carepreneur/Carepreneur";
import AddTodo from "../pages/ToDo/AddTodo";
import EditTodo from "../pages/ToDo/EditTodo";
import CsDashboard from "../pages/customerSuccess/CsDashboard";
import AddTicket from "../components/customerSuccess/AddTicket";
import ViewTicket from "../components/customerSuccess/ViewTicket";
import AgencySetting from "../pages/setting/AgencySetting";
import EditEmployee from "../pages/employee/EditEmployee";
import ResourceOveriew from "../pages/resourceOverview/ResourceOverview";
import TeamAailability from "../pages/resourceOverview/TeamAvailability";
import AllAttendance from "../pages/attendace/AllAttendance";
import AddIdeaBox from "../pages/idea/ideaBox";
import ViewIdea from "../pages/idea/ViewIdea";
import Ideas from "../pages/idea/Ideas";
import UserProfile from "../pages/userProfile/UserProfile";
import PeerPoints from "../pages/peerPoints/PeerPoints";
import CarebravoTransitionTemplate from "../pages/templates/CarebravoTransitionTemplate";
import Holidays from "../pages/holidays/Holidays";
import PeerPointsLeaderboard from "../pages/peerPoints/PeerPointsLeaderboard";
import ChatPage from "../pages/chat/ChatPage";
import MigrationTracker from "../pages/migration/MigrationTracker";
import FeatureHistory from "../pages/featureHistory/FeatureHistory";
import AgencyMigrationDetail from "../pages/migration/AgencyMigrationDetail";
import RecordMigrationDetail from "../pages/migration/RecordMigrationDetail";
import AgencyIssues from "../pages/migration/AgencyIssues";
import ManageAssignments from "../pages/migration/ManageAssignments";
import AssetRegistry from "../pages/assetRegistry/AssetRegistry";
import FeaturesAndDevelopers from "../pages/featureHistory/FeaturesAndDevelopers";
import AddDefectTask from "../pages/defect/AddDefectTask";
import Message from "../pages/Message/Message";
import AllTodo from "../pages/ToDo/AllTodo";
import ViewCalendarAdmin from "../pages/calendar/ViewCalendarAdmin";
import PodManagementPage from "../pages/podmanagement/PodManagementPage";
import AddEnhancements from "../pages/enhancements/AddEnhancment";
import ViewEnhancement from "../pages/enhancements/ViewEnhancement";
import GoalsDash from "../pages/PodGoals/GoalsDash";
import GoalDashPodDetail from "../pages/PodGoals/GoalDashPodDetail";
import GoalDetailPOD from "../pages/PodGoals/GoalDetailPOD";
import Agents from "../pages/Agents/Agents";
import AgentDetail from "../pages/Agents/AgentDetail";
import EditGoalFromTemplate from "../pages/goals/EditGoalFromTemplate";
import EditTaskTemplate from "../pages/task/EditTaskTemplate";
import AddTiming from "../pages/resourceOverview/AddTiming";
import AllAttendanceNew from "../pages/attendace/AllAttendanceNew";
import TasksMain from "../pages/Tasks/TasksMain";
import ActionsNew from "../pages/actionsnew/ActionsNew";
import CreateGoalWizard from "../pages/PodGoals/Creategoalwizard";
import { useAuth } from "../context/AuthContext";

const AppRouter = () => {
      const { userInfo } = useAuth();
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to={userInfo ? "/dashboard" : "/new_login" }/>} />
        <Route path="/new_login" element={<NewLogin />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot" element={<ForgotPasswordFlow />} />
        <Route
          path="*"
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/add_task" element={<AddTask />} />
                  <Route path="/projects" element={<Projects />} />
                  <Route path="/actions" element={<Actions />} />
                  <Route path="/actions_new" element={<ActionsNew />} />
                  <Route path="/migration_tracker" element={<MigrationTracker />} />
                  <Route path="/feature_history" element={<FeatureHistory />} />
                  <Route path="/agency_migration_detail" element={<AgencyMigrationDetail />} />
                  <Route path="/record_migration_detail" element={<RecordMigrationDetail />} />
                  <Route path="/agency_issues" element={<AgencyIssues />} />
                  <Route path="/manage_assignments" element={<ManageAssignments />} />
                  <Route path="/task_detail" element={<TaskDetail />} />
                  <Route path="/change_status" element={<ChangeStatus />} />
                  <Route path="/clock_out" element={<ClockOutTasks />} />
                  <Route path="/clock_out_task" element={<ClockOutTask />} />
                  <Route path="/goals" element={<Goals />} />
                  <Route path="/goal_view" element={<GoalView />} />
                  <Route path="/create_goal_from_template" element={<CreateGoalFromTemplate />} />
                  <Route path="/edit_goal_from_template" element={<EditGoalFromTemplate />} />
                  <Route path="*" element={<Navigate to="/dashboard" />} />
                  <Route path="/goal_add_task" element={<GoalAddTask />} />
                  <Route path="/add_project" element={<AddProject />} />
                  <Route path="/edit_project" element={<EditProject />} />
                  <Route path="/edit_task" element={<EditTask />} />
                  <Route path="/edit_task_template" element={<EditTaskTemplate />} />
                  <Route path="/edit_goal" element={<EditGoal />} />
                  <Route path="/add_dependency" element={<AddDependency />} />
                  <Route path="/add_defect" element={<AddDefect />} />
                  <Route path="/add_defect_task" element={<AddDefectTask />} />
                  <Route path="/view_defect" element={<ViewDefect />} />
                  <Route path="/add_bug" element={<AddBug />} />
                  <Route path="/add_enhancement" element={<AddEnhancements />} />
                  <Route path="/view_bug" element={<ViewBug />} />
                  <Route path="/view_enhancement" element={<ViewEnhancement />} />
                  <Route path="/add_employee" element={<AddEmployee />} />
                  <Route path="/view_pre_defects" element={<ViewPreDefects />} />
                  <Route path="/view_attendance" element={<ViewAttendance />} />
                  <Route path="/apply_leave" element={<ApplyLeave />} />
                  <Route path="/leave_management" element={<LeaveManagement />} />
                  <Route path="/employee_task_list" element={<EmployeeTaskList />} />
                  <Route path="/add_meeting" element={<AddMeeting />} />
                  <Route path="/edit_meeting" element={<EditMeeting />} />
                  <Route path="/meeting_detail" element={<MeetingDetail />} />
                  <Route path="/calendar" element={<ViewCalendar />} />
                  <Route path="/calendar_admin" element={<ViewCalendarAdmin />} />
                  <Route path="/carepreneur" element={<Carepreneur />} />
                  <Route path="/add_todo" element={<AddTodo />} />
                  <Route path="/all_todo" element={<AllTodo />} />
                  <Route path="/edit_todo" element={<EditTodo />} />
                  <Route path="/support_dashboard" element={<CsDashboard />} />
                  <Route path="/add_ticket" element={<AddTicket />} />
                  <Route path="/view_ticket" element={<ViewTicket />} />
                  <Route path="/agency_setting" element={<AgencySetting />} />
                  <Route path="/edit_employee" element={<EditEmployee />} />
                  <Route path="/resource_overiew" element={<ResourceOveriew />} />
                  <Route path="/team_availability" element={<TeamAailability />} />
                  <Route path="/all_attendance" element={<AllAttendance />} />
                  <Route path="/all_attendance_new" element={<AllAttendanceNew />} />
                  <Route path="/add_idea" element={<AddIdeaBox />} />
                  <Route path="/view_idea" element={<ViewIdea />} />
                  <Route path="/ideas" element={<Ideas />} />
                  <Route path="/user_profile" element={<UserProfile />} />
                  <Route path="/peer_points" element={<PeerPoints />} />
                  <Route path="/carebravo_transition_template" element={<CarebravoTransitionTemplate />} />
                  <Route path="/holidays" element={<Holidays />} />
                  <Route path="/peer_points_board" element={<PeerPointsLeaderboard />} />
                  <Route path="/chat_bot" element={<ChatPage />} />
                  <Route path="/asset_registry" element={<AssetRegistry />} />
                  <Route path="/features_and_developers" element={<FeaturesAndDevelopers />} />
                  <Route path="/message" element={<Message />} />
                  <Route path="/pod_management" element={<PodManagementPage />} />
                  <Route path="/goals_dash" element={<GoalsDash />} />
                  <Route path="/goals_dash_pod_detail" element={<GoalDashPodDetail />} />
                  <Route path="/goal_pod_detail" element={<GoalDetailPOD />} />
                  <Route path="/agents" element={<Agents />} />
                  <Route path="/agent/:agentId" element={<AgentDetail />} />
                  <Route path="/add_timing" element={<AddTiming />} />
                  <Route path="/tasks" element={<TasksMain />} /> 
                  <Route path="/create_pod_goal" element={<CreateGoalWizard />} />               

                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default AppRouter;